import { render, staticRenderFns } from "./PetHealthTypeFoodForm.vue?vue&type=template&id=b20cdd06&scoped=true&"
import script from "./PetHealthTypeFoodForm.vue?vue&type=script&lang=js&"
export * from "./PetHealthTypeFoodForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20cdd06",
  null
  
)

export default component.exports